import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { ProListingComponent } from './pro-listing.component';
import { ProfessionalListingRoutingModule } from './pro-listing-routing.module';
import { ProListingHeaderComponent } from './components/pro-listing-header/pro-listing-header.component';
import { ProSharedModule } from '../components/pro-shared.module';
import { ImgResizeModule } from '../../../../shared/components/img-resize/img-resize.module';
import { UtilsModule } from '../../../../utils/utils.module';
import { ProListingSearchComponent } from './components/pro-listing-search/pro-listing-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteOffModule } from '../../../../utils/directives/autocomplete-off/autocomplete-off.module';
import { ContentPlaceholderModule } from '../../../../kz-ui/ui/content-placehoder/content-placeholder.module';
import { KzTagModule } from '../../../../kz-ui/ui/tag/kz-tag.module';
import { KzButtonModule } from '../../../../kz-ui/ui/form/button/kz-button.module';
import { KzBadgeModule } from '../../../../kz-ui/ui/badge/kz-badge.module';
import { KzTooltipModule } from '../../../../kz-ui/ui/tooltip/kz-tooltip.module';
import { KzClickOutsideModule } from '../../../../kz-ui/ui/click-outside/kz-click-outside.module';
import { ProListingItemModule } from './components/pro-listing-item/pro-listing-item.module';
import { KzPaginationModule } from '../../../../kz-ui/ui/pagination/kz-pagination.module';
import { ProServiceItemModule } from '../pro-profile/components/pro-service-item/pro-service-item.module';
import { KzDropdownModule } from '../../../../kz-ui/ui/dropdown/kz-dropdown.module';
import { KzFieldModule } from '../../../../kz-ui/ui/form/field/kz-field.module';
import { KzCheckboxToggleModule } from '../../../../kz-ui/ui/form/checkbox-toggle/kz-checkbox-toggle.module';
import { KzFiltersModule } from '../../../../kz-ui/ui/filters/kz-filters.module';
import {
  FilterDropdownItemImgComponent
} from './components/filter-dropdown-item-img/filter-dropdown-item-img.component';
import { KzStickerModule } from '../../../../kz-ui/ui/sticker/kz-sticker.module';
import { KzTextBoxModule } from '../../../../kz-ui/ui/form/textbox/kz-textbox.module';
import { KzLoaderModule } from '../../../../kz-ui/ui/loader/kz-loader.module';
import { KzIconsModule } from '../../../../kz-ui/ui/icon/kz-icons.module';
import { KzCheckBoxModule } from 'src/app/kz-ui/ui/form/checkbox/kz-checkbox.module';
import { KzRadioModule } from 'src/app/kz-ui/ui/form/radio/kz-radio.module';
import { ProListingAdFaqComponent } from './components/pro-listing-ad-faq/pro-listing-ad-faq.component';
import { KzAccordionModule } from '../../../../kz-ui/ui/accordion/kz-accordion.module';
import { KzJumbotronModule } from '../../../../kz-ui/ui/jumbotron/kz-jumbotron.module';
import { GoogleMapsUtilsModule } from '../../../../shared/google-maps-utils/google-maps-utils.module';
import {
  ProListingBannerTenderComponent
} from './components/pro-listing-banner-tender/pro-listing-banner-tender.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { KzLabelModule } from '../../../../kz-ui/ui/form/label/kz-label.module';
import { ProTenderModule } from '../pro-tender/pro-tender.module';
import { KzMeshLinkModule } from '../../../../kz-ui/ui/mesh-link/kz-mesh-link.module';
import { ClickAccessControlDirective } from '../../../../utils/directives/access-control.directive';
import { ProMiscApiModule } from '@adeo/ngx-kozikaza-api/pro/misc';
import { ProCoachingFaqComponent } from "./components/pro-coaching-faq/pro-coaching-faq.component";
import { KzLocalizePipe } from "../../../../utils/pipes/i18n/kz-localize.pipe";

@NgModule({
  imports: [
    ProMiscApiModule,
    SharedModule,
    UtilsModule,
    ProfessionalListingRoutingModule,
    ProSharedModule,
    ImgResizeModule,
    GoogleMapsUtilsModule,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteOffModule,
    ProListingItemModule,
    ProServiceItemModule,
    ContentPlaceholderModule,
    KzTagModule,
    KzBadgeModule,
    KzButtonModule,
    KzTooltipModule,
    KzClickOutsideModule,
    KzPaginationModule,
    KzDropdownModule,
    KzFieldModule,
    KzFiltersModule,
    KzCheckboxToggleModule,
    KzCheckBoxModule,
    KzRadioModule,
    KzStickerModule,
    KzIconsModule,
    KzTextBoxModule,
    KzLoaderModule,
    KzAccordionModule,
    KzJumbotronModule,
    NgSelectModule,
    KzLabelModule,
    ProTenderModule,
    KzMeshLinkModule,
    ClickAccessControlDirective,
    KzLocalizePipe,
  ],
  declarations: [
    ProListingComponent,
    ProListingHeaderComponent,
    ProListingSearchComponent,
    FilterDropdownItemImgComponent,
    ProListingAdFaqComponent,
    ProCoachingFaqComponent,
    ProListingBannerTenderComponent,
  ]
})
export class ProListingModule { }
